export default __webpack_public_path__ + "maps-examples-runtime-multiple-annotations-thumbnail-480-fe4ce57d17273a13e397f0223ef38efb.webp";